var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cycle-orders" }, [
    _c("h4", [_vm._v("Limpezas agendadas para o ciclo")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar" },
      [
        _c("v-date-picker", {
          attrs: {
            color: "purple",
            "min-date": _vm.payable.starts_at,
            "max-date": _vm.payable.ends_at,
            value: null,
            "is-inline": "",
            columns: _vm.horizontal ? 2 : 1,
            masks: { weekdays: "WWW" },
            locale: "pt-BR",
            attributes: _vm.events
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aa41106", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa41106","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payable/CycleComponents/CycleOrders.vue
// module id = null
// module chunks = 